<template>
	<div class="e404">
		<div class="e404__elm">
			<div class="e404__elm-alert">Ошибка 404. Страница не найдена.</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Error404 extends Vue {}
</script>

<style scoped lang="scss">
.e404 {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		display: flex;
		justify-content: center;
	}

	&__elm-alert {
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm-alert {
			font-size: 22px;
		}
	}
}
</style>
